import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tabar-add",
  "use": "icon-tabar-add-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-tabar-add\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z\" fill=\"#EFEFEF\" p-id=\"7083\" /><path d=\"M486.4 217.6h51.2v588.8h-51.2z\" fill=\"#CCCCCC\" p-id=\"7084\" /><path d=\"M217.6 486.4h588.8v51.2H217.6z\" fill=\"#CCCCCC\" p-id=\"7085\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol